// /* Hulkapps customization - options inside a popup */
// /* Demir Pasalic, July 2025 */
// /* ---------------------------------------- */

// class Main {
// 	constructor() {
// 		this.state = {};
// 		this.modal = null;
// 		this.modalBackdrop = null;
// 		this.loading = null;
// 		this.init();
// 	}

// 	init() {
// 		window.addEventListener("HulkEvents", () => {
// 			this.modal = document.getElementById("hulk-modal");
// 			this.modalBackdrop = document.getElementById("hulk-modal-backdrop");
// 			this.loading = this.modalBackdrop.firstElementChild;
// 			this.removeHulkElements();
// 			this.attachListeners();
// 		});
// 	}

// 	showModal(productTitle) {
// 		this.modalBackdrop.classList.add('show');
// 		this.loading.classList.add("active");

// 		const interval = setInterval(() => {
// 			const optionsSet = this.modal.querySelector(".hulkapps_option_set");
// 			const atcBtn = this.modal.querySelector(".hulkapps_submit_cart");
// 			if (optionsSet && atcBtn) {
// 				clearInterval(interval);

// 				atcBtn.innerHTML = `<span class="product-buy-buttons--cta-text">Add to Cart</span>`;
// 				atcBtn.classList.add("product-buy-buttons--primary");
// 				atcBtn.setAttribute("data-transition-button", "");
// 				atcBtn.setAttribute("data-item", "secondary-button");
// 				atcBtn.setAttribute("data-text", "Add to Cart");

// 				this.modal.querySelector("h3").textContent = productTitle;

// 				this.loading.classList.remove("active");
// 				this.modal.classList.add('show');
// 			}
// 		}, 100);
// 	}

// 	hideModal() {
// 		this.loading.classList.remove("active");
// 		this.modal.classList.remove('show');
// 		this.modalBackdrop.classList.remove('show');

// 		setTimeout(() => {
// 			this.modal.querySelector(".hulk-wrapper").innerHTML = "";
// 			this.modal.querySelector("div[id^='hulkapps_custom_options']").innerHTML = "";
// 		}, 300);
// 	}

// 	attachListeners() {
// 		document.querySelectorAll(".hulk-modal-open").forEach(button => {
// 			button.addEventListener("click", e => {
// 				e.preventDefault();
// 				e.stopImmediatePropagation();
// 				e.stopPropagation();

// 				const variantId = button.dataset.variantId;

// 				this.showHulkWidget(variantId);

// 				this.showModal(button.dataset.productTitle);
// 			});
// 		});

// 		this.modal.querySelector(".hulk-modal-close")?.addEventListener("click", e => {
// 			this.hideModal();
// 		});

// 		this.modalBackdrop.addEventListener("click", () => {
// 			this.hideModal();
// 		});

// 		this.modal.querySelector("button[type='submit']").addEventListener("click", this.handleFormSubmit.bind(this));
// 	}

// 	showHulkWidget(id) {
// 		this.modal.querySelector("input[name='id']").value = id;

// 		this.modal.querySelector(".hulk-wrapper").innerHTML = `<div id="hulkapps_custom_options_${id}"></div>`;

// 		const $ = window.hulkapps_jQuery;
// 		window.hulk_add_to_cart_ele = $(".hulk-modal button[type='submit']");
// 		window.hulkappsStart(window.hulkapps_jQuery);

// 		// const interval = setInterval(() => {
// 		// 	const optionSet = document.querySelector("div[id^='hulkapps_custom_options'] .hulkapps_option_set");
// 		// 	if (optionSet) { // Options loaded
// 		// 		clearInterval(interval);

// 		// 		this.cloneOptions(optionSet);
// 		// 	}
// 		// }, 100);
// 	}

// 	removeHulkElements() {
// 		document.querySelectorAll("div[id^='hulkapps_custom_options']").forEach(el => el.remove());
// 		document.querySelectorAll("div.product-hulkapps-discount-code-html").forEach(el => el.remove());
// 	}

// 	handleFormSubmit() {
// 		this.modal.querySelector("#add-to-cart-form").addEventListener("submit", async (event) => {
// 			event.preventDefault();

// 			const form = event.target;
// 			const formData = new URLSearchParams();

// 			for (const element of form.elements) {
// 				if (!element.name || element.disabled) continue;

// 				switch (element.type) {
// 					case 'checkbox':
// 					case 'radio':
// 						if (element.checked) {
// 							formData.append(element.name, element.value);
// 						}
// 						break;
// 					default:
// 						formData.append(element.name, element.value);
// 				}
// 			}

// 			// Append static values
// 			const staticParams = "product-id=9726373790030&section-id=template--25315864576334__featured_product_Vk8NXC&sections=cart-drawer";
// 			const body = formData.toString() + "&" + staticParams;

// 			try {
// 				await Cart.addItems({
// 					method: "POST",
// 					headers: {
// 						"Content-Type": "application/x-www-form-urlencoded"
// 					},
// 					body: body
// 				}, true);

// 				this.modal.classList.remove("show");
// 				this.modalBackdrop.classList.remove("show");
// 			} catch (error) {
// 				console.error("Add to cart failed:", error);
// 			}
// 		});
// 	}
// }

// new Main();

/* Hulkapps customization - options inside a popup */
/* Demir Pasalic, July 2025 */
/* ---------------------------------------- */

class Main {
	constructor() {
		this.state = {
			isCarouselActive: false
		};
		this.loader = null;
		this.init();
	}

	init() {
		window.addEventListener("HulkEvents", () => {
			this.removeHulkElements();
			this.attachListeners();
		});
	}

	attachListeners() {
		document.querySelectorAll(".hulk-options-start").forEach(button => {
			const form = button.closest("form");
			const atcButton = form.querySelector(".product-buy-buttons--primary");

			button.disabled = false;
			button.addEventListener("click", e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				document.querySelectorAll(".hulk-options-start").forEach(button => button.style.display = "block");

				this.showLoader(button);

				this.showHulkWidget(button.nextElementSibling, atcButton);
			}, true);

			atcButton.addEventListener("click", e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();
//hulk validation first half start
const validateObjectData = validate_options(window.hulkapps.product_id);
const validateObjectValue = async () => {
  const vod = await validateObjectData;
  if (vod == true) {
//hulk validation first half end

				this.handleFormSubmit(e);
//hulk validation second half start
  }
};
validateObjectValue();
//hulk validation second half end

			});
		});
	}

	attachOptionListeners(optionSet, hulkPrice) {
		const clickImg = (value, productWrapper) => {
			const carouselNav = productWrapper.querySelector(".carousel-nav-arrow");
			if ((carouselNav && getComputedStyle(carouselNav).display == "none") || !carouselNav) {
				const images = productWrapper.querySelectorAll(`product-thumbs-element .product-media--thumb img[alt]`);

				images.forEach(img => {
					const alt = img.getAttribute("alt") || "";
					const afterPipe = alt.split("|")[1]?.trim();

					if (afterPipe === value) {
						img.closest(".product-media--thumb")?.click();
					}
				});
			} else {
				const targetElement = productWrapper.querySelector(`.carousel--wrapper .carousel--block:has(img[alt*='${value}'])`);
				if (targetElement) {
					let i = 1;
					let el = targetElement;
					while (el = el.previousElementSibling) {
						i++;
					}
					this.handleCarouselChange(carouselNav, i);
				}
			}
		};
		optionSet.querySelectorAll(".hulkapps_option.rb_render input[type='radio']").forEach(radio => {
			const productWrapper = optionSet.closest('.main-product--wrapper');
			radio.addEventListener("click", () => clickImg(this.extractOptionValue(radio.value), productWrapper));
		});

		optionSet.querySelectorAll(".hulkapps_option.ci_render li").forEach(radio => {
			const productWrapper = optionSet.closest('.main-product--wrapper');
			radio.addEventListener("click", () => clickImg(this.extractOptionValue(radio.dataset.displayVal), productWrapper));
		});

		optionSet.querySelectorAll(".hulkapps_option.swatch_render label").forEach(swatch => {
			const productWrapper = optionSet.closest('.main-product--wrapper');
			swatch.addEventListener("click", () => {
				clickImg(this.extractLabelAndPrice(this.extractOptionValue(swatch.getAttribute("aria-label"))), productWrapper);
			});
		});

		const observer = new MutationObserver(() => {
			const match = hulkPrice.getAttribute("aria-label").match(/\p{Sc}(\d+(?:\.\d{2})?)/u);
			if (match) {
				const number = parseFloat(match[1]);
				// const formattedPrice = number.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
				const formWrapper = hulkPrice.closest(".product-form--block");
				formWrapper.querySelector(".product-price--original.hulk-custom-price").textContent = this.formatPrice(number);
			}
		});
		observer.observe(hulkPrice, { attributes: true, attributeFilter: ["aria-label"] });
	}

	extractOptionValue(text) {
		const trimmedText = text.split('[')[0].trim();
		if (trimmedText.includes("|")) {
			return "| " + trimmedText.split("|")[1].trim();
		}
		return trimmedText;
	}

	showLoader(button) {
		const loader = document.createElement("span");
		loader.className = "loader";

		button.innerHTML = "";
		button.appendChild(loader);

		const interval = setInterval(() => {
			const optionSet = button.parentElement.querySelector(".hulkapps_option_set");
			const hulkPrice = button.parentElement.querySelector("#option_display_total_format");
			if (optionSet && hulkPrice) {
				clearInterval(interval);

				button.style.display = "none";

				const text = document.createElement("span");
				text.textContent = "Choose options";
				text.className = "product-buy-buttons--cta-text";

				button.innerHTML = "";
				button.appendChild(text);

				this.attachOptionListeners(optionSet, hulkPrice);
			}
		}, 50);
	}

	showHulkWidget(hulkContainer, atcButton) {
		this.removeHulkElements();

		const root = document.createElement("div");
		root.id = `hulkapps_custom_options_${hulkContainer.dataset.productId}`;

		hulkContainer.innerHTML = "";
		hulkContainer.appendChild(root);

		document.querySelectorAll(".hulk-custom-price").forEach(price => price.classList.remove("hulk-custom-price"));

		const form = hulkContainer.closest("form");
		form.querySelector(".product-price--original").classList.add("hulk-custom-price");

		const dataButton = atcButton.closest('form').querySelector('.hulk-options-start');
		if (dataButton) {
			const productJson = JSON.parse(dataButton.dataset.productJson);
			productJson && (window.hulkapps.product = productJson);
			window.product_price = window.hulkapps.product.price;
		}

		const $ = window.hulkapps_jQuery;
		window.hulk_add_to_cart_ele = $(atcButton);
		window.hulkapps.product_id = hulkContainer.dataset.productId;
		window.hulkappsStart($);
	}

	removeHulkElements() {
		document.querySelectorAll("div[id^='hulkapps_custom_options']").forEach(el => el.remove());
		document.querySelectorAll("div.product-hulkapps-discount-code-html").forEach(el => el.remove());
	}

	extractLabelAndPrice(text) {
		const match = text.match(/^(.+?)\s*\(\+?([^)]+)\)$/);

		if (match) {
			return match[1].trim();
		} else {
			return text.trim();
		}
	}

	async handleFormSubmit(e) {
		const form = e.target.closest("form");
		const formData = new URLSearchParams();

		for (const element of form.elements) {
			if (!element.name || element.disabled) continue;

			switch (element.type) {
				case 'checkbox':
				case 'radio':
					if (element.checked) {
						formData.append(element.name, element.value);
					}
					break;
				default:
					formData.append(element.name, element.value);
			}
		}

		// Append static values
		const staticParams = "product-id=9726373790030&section-id=template--25315864576334__featured_product_Vk8NXC&sections=cart-drawer";
		const body = formData.toString() + "&" + staticParams;

		try {
			await Cart.addItems({
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded"
				},
				body: body
			}, true);

			this.modal.classList.remove("show");
			this.modalBackdrop.classList.remove("show");
		} catch (error) {
			console.error("Add to cart failed:", error);
		}
	}

	async handleCarouselChange(carousel, targetPosition) {
		if (!this.state.isCarouselActive) {
			this.state.isCarouselActive = true;

			const currentPosition = carousel.querySelector(".carousel-nav-arrow--current").dataset.value;
			const difference = targetPosition - currentPosition;
			const button = difference > 0 ? carousel.querySelector(".carousel-nav-arrow--next") : carousel.querySelector(".carousel-nav-arrow--prev");

			if (currentPosition === targetPosition) return;

			for (let i = 0; i < Math.abs(difference); i++) {
				button.click();
				await new Promise(res => setTimeout(res, 100));
			}

			setTimeout(() => {
				this.state.isCarouselActive = false;
			}, 250);
		}
	}

	formatPrice(number) {
		const locale = (Shopify?.locale && Shopify?.country)
			? `${Shopify.locale}-${Shopify.country}`
			: 'en-US';

		const currency = Shopify?.currency?.active || 'USD';

		return number.toLocaleString(locale, {
			style: 'currency',
			currency,
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}
}

new Main();
